import appLocaleData from 'react-intl/locale-data/en';
import enMessages from '../locales/en_US.json';
import flattenJSON from './flatten-obj'

const EnLang = {
  messages: {
    ...flattenJSON(enMessages)
  },
  locale: 'en-US',
  data: appLocaleData
};
export default EnLang;
